module.exports = __webpack_public_path__ + "static/media/favs6.26f01835.jpg";